import React from 'react';
import { List, SearchInput, DateInput, SelectInput, ReferenceInput, AutocompleteInput } from 'react-admin';

import StatusInput from './inputs/StatusInput';
import InvoiceTypeInput from './inputs/InvoiceTypeInput';

import InvoiceRow from './InvoiceRow';

const optionText = choice => choice.name ? choice.name : '';

const SERVICE_CHOICES = [
	{ id: 'web',       name: 'Web' },
	{ id: 'core',      name: 'Core' },
	{ id: 'kern4good', name: 'Kern4Good' },
	{ id: 'infra',     name: 'Infra' },
	{ id: 'design',    name: 'Design' },
	{ id: 'lab',       name: 'Lab' },
	{ id: 'other',     name: 'Autre' },
];

const invoiceFilters = [
	<SearchInput source="q" alwaysOn />,
	<ReferenceInput source="customer_id" reference="customers" sort={{ field: 'name', order: 'ASC' }} alwaysOn>
		<AutocompleteInput optionText={optionText} label="Customer" />
	</ReferenceInput>,
	<DateInput source="start_date" alwaysOn />,
	<DateInput source="end_date" alwaysOn />,
	<StatusInput source="status" alwaysOn />,
	<InvoiceTypeInput source="invoice_type" alwaysOn />,
	<SelectInput source="service_type" label="Service" choices={SERVICE_CHOICES} allowEmpty emptyText="Tous" alwaysOn />,
];

const InvoiceList = props => (
	<List {...props} filters={invoiceFilters} sort={{ field: 'id', order: 'DESC' }} exporter={false}>
		<InvoiceRow />
	</List>
);

export default InvoiceList;